import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';


const TaxHomeHeading = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();


  return (
    <FDStack direction={isMobile ? 'column' : 'row'} spacing={4} wrap>
      <FDStack direction={'column'} spacing={isMobile ? 3 : 7} flex={4} width={'100%'}>
        <FDStack direction={'column'} alignItems={'center'} spacing={3}>
          <FDStack direction="column" width={isMobile ? '100%' : '60%'}>
            { isMobile
              ? <FDHeadlineText size="md" align="center" value={resource?.attr('title')} {...dataAttrs('tax page title')} />
              : <FDDisplayText size="lg" align="center" value={resource?.attr('title')} {...dataAttrs('tax page title')} />
            }
          </FDStack>
          { isMobile
            ? <FDBodyText size="md" align="center" value={resource.attr('subtitle')} {...dataAttrs('tax page subtitle')} />
            : <FDHeadlineText size="md" align="center" value={resource.attr('subtitle')} {...dataAttrs('tax page subtitle')} />
          }
        </FDStack>
        {resource.attr('products')?.resources()?.length() > 0 ? (
          <MetaControlField attr={'products'} />
        ) : null}
      </FDStack>
    </FDStack>
  );
};

export { TaxHomeHeading };
